import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Footer from '../components/Footer';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Typography,
  Container,
} from '@mui/material';
import ProgramCard from '../components/ProgramCard';

const AllPrograms = ({ type , title , subtitle }) => {
  const [programs, setPrograms] = useState([]);

  const fetchPrograms = async () => {
    try {
      const res = await fetch(`/${type}Programs.json`);
      if (!res.ok) throw new Error('Could not load program data');
      const data = await res.json();
      setPrograms(data);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchPrograms();
  }, []);

  return (
    <>
      <Box sx={{ py: 2, backgroundColor: '#f9f9f9' }}>
        <Container maxWidth="lg" >
          <div className='content'>
            <h1>{title}</h1>
          </div>
          <Typography variant="h6" align="center" color="text.secondary" paragraph>
            {subtitle}
          </Typography>

          <Grid container spacing={4} justifyContent="center" sx={{ alignContent:"center" }}>
            {programs.map((program) => (
              <Grid item key={program.id} xs={12} sm={6} md={4}>
                <ProgramCard program={program} type={type} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default AllPrograms;
